import React, { useEffect, useState } from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { ChannelManager } from '../../../common/manager';
import { parseInvalidDateAndFormat } from 'common/utilities/dayJsUtils';
import {
  getTime,
  getAndCheck,
  getDate,
  getAvailableTimingsBasedOnCurrentDay,
  getOpenTime,
  getCloseTime,
} from '../../../common/utilities/utils';
import PAYMENT_PROCESS from '../Constants';
import { useSelector, useDispatch } from 'react-redux';
import {
  accordianData,
  currencyConversion,
  setAddHopeCarryBagInfo,
} from '../../PaymentProcess/Presentation/orderReceivedScreenFn';
import { getTendersContent } from '@kfc-global/react-shared/redux/Actions/PaymentsContentAction';
import { getCmsClient } from 'common/utilities/cmsClient';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import Accordian from 'atoms/Accordian/Accordian';

const { phoneImg, Direction } = IMAGE_PATH;

const {
  GST,
  YOUR_ORDER,
  ORDER,
  ORDER_FROM_CAPS,
  GET_DIRECTION,
  SUB_TOTAL,
  TOTAL,
  largeCarryBagText,
  addHopeText,
  SEARCH_IN_CART,
  DELIVERY,
  PICKUP,
  ONLY_IMAGE,
  DELIVERY_FEE,
  DISCOUNT_TEXT,
  HH_MM,
  HH_MM_A,
  TOTAL_GST_INCLUDED,
} = PAYMENT_PROCESS;

export const getFilteredItems = (foodLineItems, addHope, carryBag) => {
  return foodLineItems?.filter(foodItem => foodItem?.item?.name !== addHope && foodItem?.item?.name !== carryBag);
};

export const setPhoneNumberFormat = phoneNumber => {
  phoneNumber?.substr(0, phoneNumber?.indexOf(' '));
  const ContactNumber = phoneNumber?.substr(phoneNumber?.indexOf(' ') + 1);
  return ContactNumber?.slice(0, 3) + '-' + ContactNumber?.slice(3, 6) + '-' + ContactNumber?.slice(6);
};

export const bill = (currencySymbol, orderDetails, currencyConversionFactor) => {
  return (
    <div className='priceList'>
      <span className='fonts'>{translateWithI18Next(GST)}</span>
      <span className='amount'>
        {currencySymbol}
        {currencyConversion(orderDetails?.inclusiveTaxTotal, currencyConversionFactor)}{' '}
      </span>
    </div>
  );
};

export const getChargeText = service => {
  return service?.toUpperCase() === DELIVERY
    ? translateWithI18Next(DELIVERY_FEE)
    : translateWithI18Next(PAYMENT_PROCESS.RESTAURANT_HANDLING_CHARGE);
};

export const Added_Charges = (AdditionalCharges, currencySymbol, currencyConversionFactor, service) => {
  return (
    AdditionalCharges &&
    AdditionalCharges.map(function (data, idx) {
      return (
        <div key={idx} className='priceList'>
          <span className='fonts'>{getChargeText(service)}</span>
          <span className='amount'>
            {currencySymbol}
            {currencyConversion(data?.amount, currencyConversionFactor)}{' '}
          </span>
        </div>
      );
    })
  );
};

export const getFullAddressDetails = orderReducerData =>
  `${orderReducerData?.deliveryAddress?.addressLines?.join(' ')} ${orderReducerData?.deliveryAddress?.city} ${
    orderReducerData?.deliveryAddress?.state
  } ${orderReducerData?.deliveryAddress?.country} ${orderReducerData?.deliveryAddress?.pinCode}`;

const getOrderId = orderReducerData => {
  return orderReducerData?.id
    ? ((orderReducerData?.posOrderId === null || orderReducerData?.posOrderId === '') && orderReducerData?.id) ||
        orderReducerData?.posOrderId
    : '';
};

export const billDescriptionViewAccordion = (
  orderDetails,
  paymentType,
  currencySymbol,
  currencyConversionFactor,
  getDirectionClickForMaps,
  isOpenAccordion,
) => {
  const onClickHandler = event => {
    const accordian = event?.target?.parentElement?.parentElement?.parentElement;
    accordian?.classList?.contains('terms-accordian-open')
      ? accordian?.classList?.remove('terms-accordian-open')
      : accordian?.classList?.add('terms-accordian-open');
  };

  return (
    <div className='accordion-bill'>
      <div className='accordion-bill-info'>
        <div class='circle-topp'></div>
        <div className='accordion-Title'>
          <div className='bill-accordian' id={orderDetails?.orderId}>
            <Accordian
              cssClass='bill-container'
              header={`${translateWithI18Next(ORDER)} ${orderDetails?.orderId}`}
              open={!isOpenAccordion ? true : false}
              onClickHandler={onClickHandler}
            >
              <div className='bill-accordian-description'>
                {getOrderPanelView(
                  orderDetails,
                  paymentType,
                  currencySymbol,
                  currencyConversionFactor,
                  getDirectionClickForMaps,
                )}
              </div>
            </Accordian>
          </div>
        </div>
        <div class='circle-bottomm'></div>
      </div>
    </div>
  );
};

export const viewForDelivery = (orderDetails, currencySymbol, currencyConversionFactor, paymentType) => {
  const availableTimings = getAvailableTimingsBasedOnCurrentDay(orderDetails?.operatingHours);
  const fromTime = parseInvalidDateAndFormat(getOpenTime(availableTimings), HH_MM, HH_MM_A);
  const toTime = parseInvalidDateAndFormat(getCloseTime(availableTimings), HH_MM, HH_MM_A);
  return (
    <div className='Bill'>
      <h2 className='orderFrom'>{translateWithI18Next('deliveryAddress')}</h2>
      <div className='place'>{orderDetails?.fullAddressDetails}</div>
      {orderDetails?.instruction && (
        <>
          <h2 className='orderFrom'>{translateWithI18Next('instructions')}</h2>
          <div className='place'>{orderDetails?.instruction}</div>
        </>
      )}
      <h2 className='orderFrom'>{translateWithI18Next('preparedBy')}</h2>
      <div className='place'>
        <span className='fnt-bld mob-display'>{orderDetails?.storeName} </span>
        {availableTimings?.length && <span className='hrs-view mob-display'>Hours: {`${fromTime}-${toTime}`}</span>}
      </div>
      {orderInfoTemplate(orderDetails, currencySymbol, currencyConversionFactor)}
      {orderDetails?.total && (
        <div className='totalAmount'>
          <span className='total'>{translateWithI18Next(TOTAL_GST_INCLUDED)}:</span>
          <span className='total'>
            {currencySymbol}
            {orderDetails?.total}
          </span>
        </div>
      )}
      <div class='hr-payment-type'></div>
      <div className='totalAmount mt-5'>
        <span className='total'>{translateWithI18Next('Payment')}</span>
        <span className='total payment-type'>
          {paymentType?.fields?.displayFormat === ONLY_IMAGE ? (
            <img src={paymentType?.fields?.icon?.fields?.desktopImage?.fields?.file?.url} alt='paymentMethod' />
          ) : (
            <span>{paymentType?.fields?.displayName}</span>
          )}
        </span>
      </div>
    </div>
  );
};

export const orderInfoTemplate = (orderDetails, currencySymbol, currencyConversionFactor) => (
  <>
    <div className='line'>{accordianData(orderDetails?.item, currencySymbol, currencyConversionFactor)}</div>
    <div className='price'>
      <span className='fonts'>{translateWithI18Next(SUB_TOTAL)}</span>
      <span className='amount'>
        {currencySymbol}
        {orderDetails?.subTotal}
      </span>
    </div>
    {orderDetails?.taxValue && <div>{bill(currencySymbol, orderDetails, currencyConversionFactor)}</div>}
    <div>
      {Added_Charges(orderDetails?.additionalCharges, currencySymbol, currencyConversionFactor, orderDetails?.service)}
    </div>
    {orderDetails?.discountTotal > 0 && (
      <div className='priceList'>
        <span className='fonts'>{translateWithI18Next(DISCOUNT_TEXT)}</span>
        <span className='amount'>
          {' '}
          - {currencySymbol}
          {orderDetails?.discountTotal}
        </span>
      </div>
    )}
  </>
);

export const viewForPickupDineIn = (
  orderDetails,
  paymentType,
  currencySymbol,
  currencyConversionFactor,
  getDirectionClickForMaps,
) => {
  return (
    <div className='Bill'>
      <div className='orderTitle'>
        <h2 className='yourOrder'>{translateWithI18Next(YOUR_ORDER)}</h2>
        <span className='orderId'>
          <span className='OrderClass'>{translateWithI18Next(ORDER)}</span>
          {orderDetails?.orderId}
        </span>
      </div>
      <div className='orderingDateTime'>{`${orderDetails?.orderingDate} ${translateWithI18Next('At')} ${
        orderDetails?.orderingTime
      }`}</div>
      <div className='postorder-payment-details'>
        <h2 className='payment-header'>{translateWithI18Next('paymentHeader')}</h2>
        <div className='payment-details'>
          {paymentType?.fields?.displayFormat === ONLY_IMAGE ? (
            <img src={paymentType?.fields?.icon?.fields?.desktopImage?.fields?.file?.url} alt='paymentMethod' />
          ) : (
            <span className='payment-completed'>{paymentType?.fields?.displayName}</span>
          )}
        </div>
      </div>
      <h2 className='orderFrom'>{translateWithI18Next(ORDER_FROM_CAPS)}</h2>
      <div className='place'>{orderDetails?.storeName}</div>
      <div className='Address'>{orderDetails?.addressLines}</div>
      <div className='ContactDetail'>
        <span>
          <img src={phoneImg} alt='' className='phoneIcon' />
          <span className='phoneNum'>
            <a href='tel:{orderDetails?.phoneNumber}' className='anchorTag'>
              {orderDetails?.phoneNumberFormat}
            </a>
          </span>
        </span>
        <span>
          <img src={Direction} alt='' className='phoneIcon' />
          <span
            data-testid='get-direction'
            tabIndex='0'
            className='phoneNum'
            onClick={() => getDirectionClickForMaps()}
          >
            {translateWithI18Next(GET_DIRECTION)}
          </span>
        </span>
      </div>
      {orderInfoTemplate(orderDetails, currencySymbol, currencyConversionFactor)}
      {orderDetails?.service === PICKUP && orderDetails?.carryBagDataExistsId && (
        <div className='priceList'>
          <span className='fonts'>{translateWithI18Next(largeCarryBagText)}</span>
          <span className='amount'>{orderDetails?.carryBagDataPrice}</span>
        </div>
      )}
      {Boolean(orderDetails?.addHopeDataExistsId) && (
        <div className='priceList'>
          <span className='fonts'>{translateWithI18Next(addHopeText)}</span>
          <span className='amount'>{orderDetails?.addHopeDataPrice}</span>
        </div>
      )}
      {orderDetails?.total && (
        <div className='totalAmount'>
          <span className='total'>{translateWithI18Next(TOTAL)}</span>
          <span className='total'>
            {currencySymbol}
            {orderDetails?.total}
          </span>
        </div>
      )}
    </div>
  );
};

export const getOrderPanelView = (
  orderDetails,
  paymentType,
  currencySymbol,
  currencyConversionFactor,
  getDirectionClickForMaps,
) =>
  orderDetails?.service === DELIVERY
    ? viewForDelivery(orderDetails, currencySymbol, currencyConversionFactor, paymentType)
    : viewForPickupDineIn(
        orderDetails,
        paymentType,
        currencySymbol,
        currencyConversionFactor,
        getDirectionClickForMaps,
      );

const BillDescription = ({
  orderReducerData = {},
  tenantReducer = {},
  getDirectionClickForMaps,
  enableAccordion,
  isOpenAccordion,
  orderDetailsObj = {},
}) => {
  const { tenders } = orderReducerData;
  const { currencySymbol, currencyConversionFactor, addHope, carryBag } = tenantReducer;
  const { tendersContent } = useSelector(data => data?.paymentsContentReducer);
  const { items } = tendersContent;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getTendersContent({
        object: getCmsClient(),
        contentFull: {
          content_type: 'tenders',
          include: 5,
          select: 'sys.id,fields',
        },
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [paymentType, setPaymentType] = useState({
    fields: {
      displayFormat: '',
    },
  });
  const [orderDetails, setOrderDetails] = useState({
    service: '',
    orderId: '',
    storeName: '',
    phoneNumber: '',
    subTotal: 0,
    taxValue: [],
    additionalCharges: [],
    discountTotal: 0,
    total: '',
    item: [],
    addHopeDataExistsId: '',
    carryBagDataExistsId: '',
    addHopeDataPrice: '',
    carryBagDataPrice: '',
    orderingDate: '',
    orderingTime: '',
    fullAddressDetails: '',
    instruction: '',
    addressLines: '',
    inclusiveTaxTotal: '',
    operatingHours: orderDetailsObj?.operatingTime?.operatingHours,
  });

  useEffect(() => {
    if (orderReducerData?.id) {
      const addHopeCarryBag = getAndCheck(addHope, carryBag)
        ? setAddHopeCarryBagInfo(
            orderReducerData,
            addHope,
            carryBag,
            SEARCH_IN_CART,
            undefined,
            undefined,
            tenantReducer,
          )
        : {};

      setOrderDetails({
        service: orderReducerData?.service?.toUpperCase(),
        orderId: getOrderId(orderReducerData),
        storeName: orderReducerData?.store?.name,
        phoneNumber: orderReducerData?.store?.phoneNumber,
        phoneNumberFormat: setPhoneNumberFormat(orderReducerData?.store?.phoneNumber),
        subTotal: currencyConversion(orderReducerData?.subTotal, currencyConversionFactor),
        taxValue: orderReducerData?.taxLines,
        additionalCharges: orderReducerData?.additionalChargeLines,
        discountTotal: currencyConversion(orderReducerData?.discountTotal, currencyConversionFactor),
        total: currencyConversion(orderReducerData?.total, currencyConversionFactor),
        item: getFilteredItems(orderReducerData?.foodLines, addHope, carryBag),
        addHopeDataExistsId: addHopeCarryBag?.addHopeDataExistsId || '',
        carryBagDataExistsId: addHopeCarryBag?.carryBagDataExistsId || '',
        addHopeDataPrice: addHopeCarryBag?.addHopeDataPrice || '',
        carryBagDataPrice: addHopeCarryBag?.carryBagDataPrice || '',
        orderingDate: getDate(orderReducerData?.orderingDateTime),
        orderingTime: getTime(orderReducerData?.orderingDateTime),
        fullAddressDetails: getFullAddressDetails(orderReducerData),
        instruction: orderReducerData?.instruction,
        addressLines: orderReducerData?.store?.address?.addressLines,
        inclusiveTaxTotal: orderReducerData?.inclusiveTaxTotal,
        operatingHours: orderDetailsObj?.operatingTime?.operatingHours,
      });

      (async () => {
        await ChannelManager.BindOrder();
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderReducerData?.id, addHope, carryBag]);

  useEffect(() => {
    if (getAndCheck(items?.length, tenders?.length)) {
      items.forEach(data => {
        if (data.fields.title === tenders[0].type) {
          setPaymentType(data);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenders]);

  return enableAccordion
    ? billDescriptionViewAccordion(
        orderDetails,
        paymentType,
        currencySymbol,
        currencyConversionFactor,
        getDirectionClickForMaps,
        isOpenAccordion,
      )
    : getOrderPanelView(orderDetails, paymentType, currencySymbol, currencyConversionFactor, getDirectionClickForMaps);
};

export default BillDescription;
